const React = require('react');
const ReactRedux = require('react-redux');
const createReactClass = require('create-react-class');

const EnvironmentDetails = createReactClass({
	getInitialState: function() {
		return {
			open: false
		};
	},
	toggle: function() {
		this.setState({
			open: !this.state.open
		});
	},
	render: function() {
		let table = null;
		let caret = 'fa fa-caret-down';
		let action = 'View';
		if (this.state.open) {
			table = (
				<div className="table-responsive environment-details-data">
					<table className="table">
						<tbody>
							{
								Object.keys(this.props.details).map(function(name) {
									return (
										<tr key={name}>
											<td>{name}</td>
											<td>{this.props.details[name]}</td>
										</tr>
									);
								}.bind(this))
							}
						</tbody>
					</table>
				</div>
			);
			caret = 'fa fa-caret-up';
			action = 'Hide';
		}
		return (
			<span>
				<a href="javascript:void(0)" onClick={this.toggle}>{action} environment details <i className={caret}></i></a>
				{table}
			</span>
		);
	}
});

const mapStateToProps = function(state) {
	return {
		details: state.environment.details
	};
};

module.exports = ReactRedux.connect(mapStateToProps)(EnvironmentDetails);
